import Joi from 'joi';
import { objectId } from '@/shared/validations/custom.validation';

export const getPushNotifications = {
  query: Joi.object().keys({
    search: Joi.string(),
    sortBy: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    receivedTo: Joi.string().custom(objectId),
    includeTimeStamps: Joi.boolean(),
    read: Joi.boolean(),
  }),
};

export const updatePushNotification = () => ({
  params: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: Joi.object()
    .keys({
      read: Joi.boolean().required(),
    })
    .required(),
});

export const bulkUpdatePushNotifications = () => ({
  body: Joi.object({
    read: Joi.boolean().required(),
  }).required(),
});
